import * as React from 'react';
import { ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import { TOOLBAR_IMAGE_TRANS } from '@editor/src/img/pageIndex';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import { TDWActionType, TDWModuleType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.TRANSPARENCY,
    tipMsg: i18n.t('图片透明度'),
    title: i18n.t('图片透明度'),
    titleForBig: i18n.t('透明度'),
    icon: TOOLBAR_IMAGE_TRANS,
    twdConfig: {
        module: TDWModuleType.PC_TOOLBAR_PIC,
        action: TDWActionType.TRANSPARENCY,
        notReportVer5: true,
    },
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: config.tipMsg,
    },
    {
        name: wrapIdForBig(config.id),
        icon: <img src={config.icon} alt={''}/>,
        text: config.titleForBig,
        tooltip: config.tipMsg,
        style: {
        },
    },
];
